class SPdpAnatomy extends HTMLElement {
  #ac;

  connectedCallback() {
    this.#ac = new AbortController();
    const opts = { signal: this.#ac.signal };
    this.setAttribute('data-js', '');
    const items = [...this.querySelectorAll('[data-item]')];
    const spots = [...this.querySelectorAll('[data-spot]')];

    const activate = (id) => {
      this.setAttribute('data-active', id);
      items.forEach((el) => {
        const on = el.dataset.item === id;
        el.toggleAttribute('data-on', on);
        el.setAttribute('aria-expanded', String(on));
      });
      spots.forEach((el) => el.toggleAttribute('data-on', el.dataset.spot === id));
    };

    items.forEach((el) => {
      el.addEventListener('click', () => activate(el.dataset.item), opts);
      el.addEventListener('mouseenter', () => activate(el.dataset.item), opts);
      el.addEventListener('focus', () => activate(el.dataset.item), opts);
    });
    spots.forEach((el) => {
      el.addEventListener('mouseenter', () => activate(el.dataset.spot), opts);
      el.addEventListener('click', () => activate(el.dataset.spot), opts);
    });

    if (items[0]) activate(items[0].dataset.item);
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }
}

if (!customElements.get('s-pdp-anatomy')) customElements.define('s-pdp-anatomy', SPdpAnatomy);
